import angular from 'angular';
import BrandsComponent from './brands.component';

let BrandsModule = angular.module('home.brands', [])
  .component('brands', BrandsComponent);

export default BrandsModule;



// WEBPACK FOOTER //
// ./www/components/home/brands/brands.js